import React, { Fragment, useEffect, useState } from "react";
import styles from "Components/Topology/topology.module.scss";
import { Form, Select, Row, Col, Divider, InputNumber } from "antd";
import { useAppSelector } from "store/hook";
import { setFields, SYSTEMProps } from "./setField";

const { Option } = Select;

const M300Type = [
  { value: "sms", name: "SMS" },
  { value: "vpn-disconnect", name: "VPN disconnect" },
  { value: "wan-disconnect", name: "WAN disconnect" },
  { value: "reboot", name: "Reboot" },
  { value: "thermal", name: "Thermal" },
  { value: "data-limit", name: "Data-Limit" },
  { value: "data-block", name: "Data-Block" },
  { value: "lan-eth-disconnect", name: "LAN disconnect" },
  { value: "di1", name: "DI1" },
  { value: "di2", name: "DI2" },
  { value: "geofence", name: "Geofence" },
];
// M301-GW-A(無LTE版本)
const M301GEAType = [
  { value: "sms", name: "SMS" },
  { value: "vpn-disconnect", name: "VPN disconnect" },
  { value: "wan-disconnect", name: "WAN disconnect" },
  { value: "reboot", name: "Reboot" },
  { value: "thermal", name: "CPU Thermal" },
  { value: "lan-wifi-disconnect", name: "AP lost all" },
  { value: "lan-eth-disconnect", name: "LAN disconnect" },
  { value: "di1", name: "DI1" },
  { value: "di2", name: "DI2" },
];

const AlarmM301 = React.memo(({ SubmitConfigonFinish, form }: SYSTEMProps) => {
  const [AlarmEnable, setAlarmEnable] = useState<boolean>(false);
  const [AlarmType, setAlarmType] = useState<string[]>([]);
  const [GPSReference, setGPSReference] = useState(false);

  const { formData, importSource, selectedModel } = useAppSelector((state) => state.topology);
  const hasGPS = formData?.system?.alarm?.inputs?.includes("geofence");
  const alarm = formData?.system?.alarm;

  useEffect(() => {
    setAlarmEnable(alarm?.mode || false);
    setGPSReference(alarm?.geofence?.auto_detect);
    setAlarmType(alarm?.inputs);

    if (importSource === "NewConfig") {
      return;
    }

    setFields(alarm, form);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  return (
    <Form onFinish={SubmitConfigonFinish} form={form} scrollToFirstError layout="vertical">
      <div className="formwrap">
        <Row gutter={24} justify="space-around">
          <Col xs={24} sm={24} md={24} lg={24} xl={10}>
            <h2>Type</h2>
            <Divider className={styles.divider} />
            <Form.Item
              name={"alarm_enabled"}
              label="Alarm Enable"
              rules={[{ required: true, message: "required!" }]}
              initialValue={false}
            >
              <Select
                onChange={(value: any) => {
                  setAlarmEnable(value);
                  form.validateFields(["alarm_input", "gps_radius", "gps_latitude", "gps_longitude"]);
                }}
                placeholder={"ON/OFF"}
              >
                {/* @ts-ignore */}
                <Option key={0} value={true}>
                  ON
                </Option>
                {/* @ts-ignore */}
                <Option key={1} value={false}>
                  OFF
                </Option>
              </Select>
            </Form.Item>

            <Form.Item
              name={"alarm_input"}
              label="Type"
              rules={[{ required: AlarmEnable, message: "required!" }]}
              initialValue={["sms"]}
            >
              <Select
                onChange={(value: string[]) => {
                  setAlarmType(value);
                  selectedModel !== "M301-GW-A" && form.validateFields(["gps_radius", "gps_latitude", "gps_longitude"]);
                }}
                mode="multiple"
                maxTagCount={"responsive"}
                placeholder={"VPN, SMS ...."}
                disabled={!AlarmEnable}
              >
                {selectedModel === "M301-GW-A"
                  ? M301GEAType.map((item, index) => {
                      return (
                        <Option key={index} value={item.value}>
                          {item.name}
                        </Option>
                      );
                    })
                  : M300Type.map((item, index) => {
                      if (item.value === "geofence" && !hasGPS) {
                        return;
                      }

                      return (
                        <Option key={index} value={item.value}>
                          {item.name}
                        </Option>
                      );
                    })}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={10}>
            {selectedModel === "M301-GW-A" || importSource === "Device" ? (
              <>
                {AlarmType?.includes("thermal") && (
                  <>
                    <h2>CPU Thermal</h2>
                    <Divider className={styles.divider} />
                    <Form.Item
                      name={"cpu_low"}
                      label="Low (°C)"
                      rules={[
                        {
                          required: AlarmType?.includes("thermal") && AlarmEnable,
                          message: "required!",
                        },
                        {
                          type: "number",
                          max: 100,
                          min: -40,
                          message: "Temperature range should be -40~100",
                        },
                      ]}
                      initialValue={-40}
                      tooltip={"Issue an alert when device is out of range"}
                    >
                      <InputNumber
                        style={{ width: "100%" }}
                        placeholder="-40~100"
                        max={100}
                        min={-40}
                        disabled={!AlarmEnable || !AlarmType?.includes("thermal")}
                      />
                    </Form.Item>
                    <Form.Item
                      name={"cpu_high"}
                      label="High (°C)"
                      rules={[
                        {
                          required: AlarmType?.includes("thermal") && AlarmEnable,
                          message: "required!",
                        },
                        {
                          type: "number",
                          max: 100,
                          min: -40,
                          message: "Temperature range should be -40~100",
                        },
                      ]}
                      initialValue={95}
                      tooltip={"Issue an alert when device is out of range"}
                    >
                      <InputNumber
                        style={{ width: "100%" }}
                        max={100}
                        min={-40}
                        placeholder="-40~100"
                        disabled={!AlarmEnable || !AlarmType?.includes("thermal")}
                      />
                    </Form.Item>
                  </>
                )}
                {(AlarmType?.includes("di1") || AlarmType?.includes("di2")) && (
                  <>
                    <h2>DI Trigger</h2>
                    <Divider className={styles.divider} />
                  </>
                )}

                {AlarmType?.includes("di1") && (
                  <Form.Item
                    name={"di_d1_trigger"}
                    label="DI 1 Trigger"
                    rules={[
                      {
                        required: AlarmType?.includes("di1"),
                        message: "required!",
                      },
                    ]}
                    initialValue={true}
                    // tooltip={"Issue an alert when device is out of range"}
                  >
                    <Select disabled={!AlarmEnable || !AlarmType?.includes("di1")} placeholder={"High/Low"}>
                      {/* @ts-ignore */}
                      <Option key={0} value={"high"}>
                        High
                      </Option>
                      {/* @ts-ignore */}
                      <Option key={1} value={"low"}>
                        Low
                      </Option>
                    </Select>
                  </Form.Item>
                )}
                {AlarmType?.includes("di2") && (
                  <Form.Item
                    name={"di_d2_trigger"}
                    label="DI 2 Trigger"
                    rules={[
                      {
                        required: AlarmType?.includes("di2"),
                        message: "required!",
                      },
                    ]}
                    initialValue={true}
                    // tooltip={"Issue an alert when device is out of range"}
                  >
                    <Select disabled={!AlarmEnable || !AlarmType?.includes("di2")} placeholder={"High/Low"}>
                      {/* @ts-ignore */}
                      <Option key={0} value={"high"}>
                        High
                      </Option>
                      {/* @ts-ignore */}
                      <Option key={1} value={"low"}>
                        Low
                      </Option>
                    </Select>
                  </Form.Item>
                )}
              </>
            ) : (
              <>
                <h2>GPS Detection</h2>
                <Divider className={styles.divider} />
                <Form.Item
                  name={"gps_radius"}
                  label="Radius(m)"
                  rules={[
                    {
                      required: AlarmType?.includes("geofence") && AlarmEnable,
                      message: "required!",
                    },
                    {
                      type: "number",
                      max: 100000,
                      min: 100,
                      message: "Radius range should be 100-100000",
                    },
                  ]}
                  initialValue={150}
                  tooltip={"Issue an alert when device is out of range"}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    placeholder="100~100000"
                    disabled={!AlarmEnable || !AlarmType?.includes("geofence")}
                  />
                </Form.Item>
                <Form.Item
                  name="gps_reference"
                  label="Reference"
                  rules={[
                    {
                      required: AlarmType?.includes("geofence"),
                      message: "required!",
                    },
                  ]}
                  initialValue={true}
                  tooltip={"Setting device location by manual input/Auto detect by GPS"}
                >
                  <Select
                    disabled={!AlarmEnable || !AlarmType?.includes("geofence")}
                    onChange={(value: any) => {
                      setGPSReference(value);
                    }}
                    placeholder={"Manual/Auto"}
                  >
                    {/* @ts-ignore */}
                    <Option key={0} value={true}>
                      Auto Detect
                    </Option>
                    {/* @ts-ignore */}
                    <Option key={1} value={false}>
                      Self Define
                    </Option>
                  </Select>
                </Form.Item>
              </>
            )}

            {selectedModel !== "M301-GW-A" && GPSReference === false && (
              <Fragment>
                <Form.Item
                  name={"gps_latitude"}
                  label="Latitude"
                  rules={[
                    {
                      required: AlarmType?.includes("geofence") && AlarmEnable,
                      message: "required!",
                    },
                    {
                      type: "float",
                      message: "Input must be floating-point number",
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    max={89.999999}
                    min={-89.999999}
                    placeholder="-90~90"
                    disabled={!AlarmType?.includes("geofence") || !AlarmEnable}
                  />
                </Form.Item>
                <Form.Item
                  name={"gps_longitude"}
                  label="Longitude"
                  rules={[
                    {
                      required: AlarmType?.includes("geofence") && AlarmEnable,
                      message: "required!",
                    },
                    {
                      type: "float",
                      message: "Input must be floating-point number",
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    // precision={0.00001}
                    max={179.999999}
                    min={-179.999999}
                    placeholder="-180~180"
                    disabled={!AlarmType?.includes("geofence") || !AlarmEnable}
                  />
                </Form.Item>
              </Fragment>
            )}
          </Col>
        </Row>
      </div>
    </Form>
  );
});

export default AlarmM301;

////////////////////////////////////////////

export function assemble(values: any) {
  let alarm301GWA: any = {
    mode: values.alarm_enabled,
  };

  if ((values.cpu_high || values.cpu_low) && values.alarm_enabled) {
    alarm301GWA.thermal = {};
    alarm301GWA.thermal.high = values.cpu_high || 95;
    alarm301GWA.thermal.low = values.cpu_low || -40;
  }
  if ((values.di_d1_trigger || values.di_d2_trigger) && values.alarm_enabled) {
    alarm301GWA.digital_inputs = [];
    alarm301GWA.digital_inputs[0] = {};
    alarm301GWA.digital_inputs[1] = {};
  }
  if (values.di_d1_trigger && values.alarm_enabled) {
    alarm301GWA.digital_inputs[0].trigger = values.di_d1_trigger || "high";
  }
  if (values.di_d2_trigger && values.alarm_enabled) {
    alarm301GWA.digital_inputs[1].trigger = values.di_d2_trigger || "high";
  }

  if (values.alarm_enabled) {
    alarm301GWA.inputs = values.alarm_input;
  }

  if (values.gps_radius || values.gps_reference) {
    let alarm301: any = {
      mode: values.alarm_enabled,
      geofence: {
        radius_m: values.gps_radius || 150,
        auto_detect: values.gps_reference || false,
      },
    };

    if (values.alarm_enabled) {
      alarm301.inputs = values.alarm_input;
    } else {
      alarm301.inputs = ["geofence"];
    }

    if (!values.gps_reference) {
      alarm301.geofence.latitude = values.gps_latitude || 10.123456;
      alarm301.geofence.longitude = values.gps_longitude || 10.123456;
    }

    const system = {
      alarm: alarm301,
    };
    return system;
  }

  const system = {
    alarm: alarm301GWA,
  };
  return system;
}
